import { Menu } from "devextreme-react";
import { useAuth } from "../../auth/auth-provider/auth-provider";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { persianLanguage } from "../../../constants/persianTerms";
import './user-menu.css';
import axiosHttp from "../../interceptors/axios-interceptor";
import { NOTIFICATION_API_URL, WS_BASE_API } from "../../../constants/api";
import { generalErrorMessage } from "../../errors/general-errors/general-errors";

export default function UserMenu(){
    const auth = useAuth();
    const [menuItems, setMenuItems] = useState([]);
    const [notificationsCount, setNotificationsCount] = useState(0);
    const [notificationName, setNotificationName] = useState(null)

    useEffect(()=>{
        getUnreadNotificationsCount();
    }, [notificationsCount])


    // useEffect(() => {
    //     const ws = new WebSocket(
    //         `${WS_BASE_API}notifications/not-read/count/?token=${auth.token}`,

    //         );
    //     ws.onopen = (event) => {
    //     };
    //     ws.onmessage = function (event) {
    //         console.log('websockert data: ', event.data)
    //       const data = JSON.parse(event.data)
    //         setNotificationsCount(event.message)
    //     };
    //     ws.onclose = function(event){};
    //     return () =>{
    //         if (ws.readyState === 1) { 
    //             ws.close();
    //         }}
    //   }, [auth.token]);


    const getUnreadNotificationsCount = () => 
    {
        if(auth.user){
            axiosHttp.get(`${NOTIFICATION_API_URL}unread/${auth.user.userType}/count/`).then((response) => {
                setNotificationsCount(response.data.count);
                
                setNotificationName(`${persianLanguage.word.notification.NOTIFICATIONS} ${notificationsCount}`)
            }).catch((error) => {
                if(error.response){
                    generalErrorMessage(error.response.status);
                } else {
                    generalErrorMessage(error.status)
                }
                setNotificationsCount(0)
            });
        }
    };


    const logout =  () => {
        auth.logout();
    }
    const showSubmenuModes = [
        {
          name: 'onHover',
          delay: { show: 0, hide: 500 },
        },
        {
          name: 'onClick',
          delay: { show: 0, hide: 300 },
        },
    ];

    useEffect(()=>{
        if(auth.token){
            const fullName = auth?.user?.fullName || persianLanguage.word.user.USER_MENU;
            const items = [
                {
                    id: '1',
                    name: fullName,
                    items: [
                        {
                            id: '1_1',
                            name: persianLanguage.word.user.PROFILE,
                            route: `/profiles/${auth.user.profileId}/`,
                            icon: 'user',
                            englishName: 'profile',
                        },
                        // {
                        //     id: '1_2',
                        //     name: `${persianLanguage.word.notification.NOTIFICATIONS} (${notificationsCount})`,
                        //     route: `/notifications`,
                        //     icon: 'bell',
                        //     englishName: 'notification',
                        // },
                        // {
                        //     id: '1_3',
                        //     name: persianLanguage.word.transaction.TRANSACTIONS,
                        //     route: '/transactions',
                        //     icon: 'money',
                        // },
                        // {
                        //     id: '1_4',
                        //     name: persianLanguage.word.receipt.RECEIPT,
                        //     route: `/receipts`,
                        //     englishName: 'receipts',
                        //     icon: 'money',
                        // },
                        {
                            id: '1_5',
                            name: persianLanguage.word.user.LOGOUT,
                            route: '/login',
                            englishName: 'logout',
                            icon: 'runner',
                        },
                    ],
                },
            ]
            setMenuItems(items);
        }
    

    },[auth.token, notificationsCount])

    const navigate = useNavigate();
    const [currentRoute, setCurrentRoute] = useState('');
    const [orientation, setOrientation] = useState('horizontal');
    const [hideSubmenuOnMouseLeave, setHideSubmenuOnMouseLeave] = useState(false);
    const [showFirstSubmenuModes, setShowFirstSubmenuModes] = useState(showSubmenuModes[1]);

    const itemClick = useCallback(
        (e) => {
        if(e.itemData.englishName === 'logout'){
            logout();
            navigate(e.itemData.route);
        } else {
          navigate(e.itemData.route)
        }
      }, [setCurrentRoute]);


    if(auth.token){
        return (
            <>
                <div className="flex flex-row-reverse">
                    <Menu
                        dataSource={menuItems}
                        displayExpr="name"
                        showFirstSubmenuMode={showFirstSubmenuModes}
                        orientation={orientation}
                        hideSubmenuOnMouseLeave={hideSubmenuOnMouseLeave}
                        onItemClick={itemClick}
                    />
                </div>
            </>
        );
    }

}